import { createContext } from "react";

export const MyContext = createContext()

export const Consumer = MyContext.Consumer
export const Provider = MyContext.Provider